import React from 'react'
import { useState,useEffect } from 'react';
import { useRef } from 'react';

const OneDayTimer = ({currentTime}) => {
    const [time, setTime] = useState({});
  const [isNegative, setIsNegative] = useState(false)
  const timerRef = useRef();
  // The data/time we want to countdown to
  const countDownDate = currentTime ? new Date(new Date(currentTime).getTime() + (24 * 60 * 60 * 1000)) : new Date(new Date().toDateString() + ' 24:00:00').getTime();

  useEffect(
    () => {
      timerRef.current = setInterval(function () {
        const now = new Date().getTime();
        const timeleft = countDownDate - now;

        const hours = Math.floor(
          (timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeleft % (1000 * 60)) / 1000);

        if (hours < 0 || minutes < 0 || seconds < 0) {
          setIsNegative(true);
        }
        // Result is output to the specific element
        // document.getElementById('days').innerHTML = days + 'd ';
        setTime({ h: hours, m: minutes, s: seconds });

        // Display the message when countdown is over
        if (timeleft < 0) {
          clearInterval(timerRef.current);
          // setTime to 0
        }
      }, 1000);
    },
    [],
    () => {
      clearInterval(timerRef.current);
    }
  );
  return (
    <div className={` font-bold text-red-500`}>
        <div className="grid grid-cols-3 gap-x-2 w-24 md:w-32">
        <div className="text-center text-sm md:text-lg">{time?.h}</div>
        {/* <div className="row-span-2 text-center ">:</div> */}
        <div className="text-center text-sm md:text-lg">{time?.m}</div>
        {/* <div className="row-span-2 text-center">:</div> */}
        <div className="text-center text-sm md:text-lg">{time?.s}</div>
        <div className="text-center font-normal text-supertiny">Hours</div>
        <div className="text-center font-normal text-supertiny">Mins</div>
        <div className="text-center font-normal text-supertiny">Secs</div>
        </div>
    </div>
  )
}

export default OneDayTimer
